module.exports = __webpack_public_path__ + "static/media/clockRed.7e3b4503.svg";